import { createSlice } from "@reduxjs/toolkit";
import { fetchEmail2faVerified } from "../thunks/fetch-email-2fa-verified-thunk";   

const initialState = {
    data: {
        // isVerified: false,
        // email2fa: "",
    },
    status: "idle",
    error: null
    
};

export const email2faVerifiedSlice = createSlice({
    name: "email2faVerifiedSlice",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchEmail2faVerified.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchEmail2faVerified.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.status = "succeeded";
            })
            .addCase(fetchEmail2faVerified.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = "failed";
            });
    }
});

export const selectEmail2faData = (state) => state.email2faVerifiedSlice.data;
export const selectEmail2faStatus = (state) => state.email2faVerifiedSlice.status;
// export const { resetSignIn } = signInSlice.actions;
